export const validateImage = file => {
  if (!file.type.includes('image/') || file.type.includes('image/gif')) {
    alert('File must be an image (PNG, JPG, JPEG)');
    return false;
  }
  if (file.size > 1024 * 1024) {
    alert('File size must be less than 1 MB');
    return false;
  }
  return true;
};

export const isFile = value => {
  return value.startsWith('data:');
  // check if the name is a file or a link
  // return name.match(/\.(jpeg|jpg|gif|png|pdf)$/) != null;
};

export const isImageLinkValidator = str => {
  // Regular expression to match a URL that ends with common image file extensions
  const imageLinkRegex = /\.(png|jpg|jpeg)$/i;

  // Check if the string is a valid URL
  const isURL = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(str);

  // Check if the URL ends with a common image file extension
  const endsWithImage = imageLinkRegex.test(str);

  // Return true if it's a valid URL and ends with a common image file extension
  return isURL && endsWithImage;
};

export const isPDFLink = str => {
  // Regular expression to match a URL that ends with .pdf
  const pdfLinkRegex = /\.(pdf)$/i;

  // Check if the string is a valid URL
  const isURL = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(str);

  // Check if the URL ends with .pdf
  const endsWithPDF = pdfLinkRegex.test(str);

  // Return true if it's a valid URL and ends with .pdf
  return isURL && endsWithPDF;
};

export const validateContent = displayPocToolContent => {
  let minitoolFound = false;

  if (displayPocToolContent.length === 0) {
    alert('Add at least one Category');
    return false;
  }

  for (let index = 0; index < displayPocToolContent.length; index++) {
    const item = displayPocToolContent[index];

    if (item.type === 'minitool') {
      if (minitoolFound && displayPocToolContent[0].type !== 'minitool') {
        alert('Minitools should only appear at the beginning.');
        return false;
      }
      minitoolFound = true;
    } else if (item.type === 'category') {
      const firstTopicIndex = displayPocToolContent.findIndex(
        (item, subIndex) => item.type === 'topic' && subIndex > index,
      );
      const firstSubtopicIndex = displayPocToolContent.findIndex(
        (item, subIndex) => item.type === 'subTopic' && subIndex > index,
      );

      // Check if there is a topic before a subtopic or if there is a subtopic without a topic.
      if (
        (firstTopicIndex > firstSubtopicIndex && firstSubtopicIndex > -1) ||
        (firstTopicIndex === -1 && firstSubtopicIndex > -1)
      ) {
        alert('A topic should be before a subtopic');
        return false;
      }
    }
  }

  return true;
};
